// extracted by mini-css-extract-plugin
export default {"content":"style_content__6NUzq","itemName":"style_itemName__8gXa+"};